module.exports = __webpack_public_path__ + "img/news.3f412078.png";